import React from 'react';
import SEO from '../components/SEO';

const Datenschutz: React.FC = () => {
  return (
    <div className="min-h-screen bg-white dark:bg-background-dark">
      <SEO 
        title="Datenschutz"
        description="Datenschutzerklärung des HSV Berlin-Adlershof e.V. - Informationen zum Umgang mit personenbezogenen Daten."
        url="/datenschutz"
        breadcrumbs={[
          { name: 'Startseite', url: '/' },
          { name: 'Datenschutz', url: '/datenschutz' }
        ]}
      />
      {/* Hero Section */}
      <section className="relative h-[400px] overflow-hidden">
        <div className="absolute inset-0">
          <img 
            src="/images/facilities/clubhouse.jpg" 
            alt="Vereinshaus" 
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/60"></div>
        </div>
        <div className="relative h-full flex items-center">
          <div className="container mx-auto px-4 max-w-5xl">
            <div className="max-w-2xl">
              <h1 className="text-3xl md:text-5xl font-black text-white mb-4 md:mb-6 uppercase">
                Datenschutz
              </h1>
            </div>
          </div>
        </div>
      </section>

      <section className="py-8 md:py-16">
        <div className="container mx-auto px-4 max-w-5xl">
          <div>

            <div className="space-y-6 md:space-y-8">
              <div className="bg-gray-50 dark:bg-surface-dark rounded-lg p-5 md:p-8">
                <h2 className="text-xl md:text-2xl font-bold mb-4 md:mb-6 text-neutral-900 dark:text-neutral-100">
                  1. Datenschutz auf einen Blick
                </h2>
                
                <div className="space-y-6">
                  <div>
                    <h3 className="text-lg md:text-xl font-semibold mb-2 md:mb-3 text-neutral-900 dark:text-neutral-100">
                      Allgemeine Hinweise
                    </h3>
                    <p className="text-neutral-600 dark:text-neutral-400">
                      Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren 
                      personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene 
                      Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.
                    </p>
                  </div>

                  <div>
                    <h3 className="text-lg md:text-xl font-semibold mb-2 md:mb-3 text-neutral-900 dark:text-neutral-100">
                      Datenerfassung auf dieser Website
                    </h3>
                    <p className="text-neutral-600 dark:text-neutral-400 mb-4">
                      <strong className="text-neutral-900 dark:text-neutral-100">Wer ist verantwortlich für die Datenerfassung auf dieser Website?</strong><br />
                      Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen 
                      Kontaktdaten können Sie dem Impressum dieser Website entnehmen.
                    </p>
                    <p className="text-neutral-600 dark:text-neutral-400">
                      <strong className="text-neutral-900 dark:text-neutral-100">Wie erfassen wir Ihre Daten?</strong><br />
                      Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann 
                      es sich z.B. um Daten handeln, die Sie in ein Kontaktformular eingeben. Andere Daten 
                      werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website durch unsere 
                      IT-Systeme erfasst. Das sind vor allem technische Daten (z.B. Internetbrowser, 
                      Betriebssystem oder Uhrzeit des Seitenaufrufs).
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-gray-50 dark:bg-surface-dark rounded-lg p-5 md:p-8">
                <h2 className="text-xl md:text-2xl font-bold mb-4 md:mb-6 text-neutral-900 dark:text-neutral-100">
                  2. Hosting
                </h2>
                <p className="text-neutral-600 dark:text-neutral-400">
                  Diese Website wird extern gehostet. Die personenbezogenen Daten, die auf dieser Website 
                  erfasst werden, werden auf den Servern des Hosters gespeichert. Hierbei kann es sich v. a. 
                  um IP-Adressen, Kontaktanfragen, Meta- und Kommunikationsdaten, Vertragsdaten, 
                  Kontaktdaten, Namen, Websitezugriffe und sonstige Daten, die über eine Website generiert 
                  werden, handeln.
                </p>
              </div>

              <div className="bg-gray-50 dark:bg-surface-dark rounded-lg p-5 md:p-8">
                <h2 className="text-xl md:text-2xl font-bold mb-4 md:mb-6 text-neutral-900 dark:text-neutral-100">
                  3. Allgemeine Hinweise und Pflichtinformationen
                </h2>
                
                <div className="space-y-6">
                  <div>
                    <h3 className="text-lg md:text-xl font-semibold mb-2 md:mb-3 text-neutral-900 dark:text-neutral-100">
                      Datenschutz
                    </h3>
                    <p className="text-neutral-600 dark:text-neutral-400">
                      Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir 
                      behandeln Ihre personenbezogenen Daten vertraulich und entsprechend den gesetzlichen 
                      Datenschutzvorschriften sowie dieser Datenschutzerklärung.
                    </p>
                  </div>

                  <div>
                    <h3 className="text-lg md:text-xl font-semibold mb-2 md:mb-3 text-neutral-900 dark:text-neutral-100">
                      Hinweis zur verantwortlichen Stelle
                    </h3>
                    <p className="text-neutral-600 dark:text-neutral-400">
                      Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:<br /><br />
                      <span className="text-neutral-900 dark:text-neutral-100">
                        Hundesportverein Berlin-Adlershof e.V.<br />
                        Toni Meier<br />
                        Birkenweg<br />
                        12439 Berlin<br /><br />
                        Telefon: 0162 / 2068729<br />
                        E-Mail: hsv.berlin.adlershof@gmail.com
                      </span>
                    </p>
                  </div>

                  <div>
                    <h3 className="text-lg md:text-xl font-semibold mb-2 md:mb-3 text-neutral-900 dark:text-neutral-100">
                      Speicherdauer
                    </h3>
                    <p className="text-neutral-600 dark:text-neutral-400">
                      Soweit innerhalb dieser Datenschutzerklärung keine speziellere Speicherdauer genannt wurde, 
                      verbleiben Ihre personenbezogenen Daten bei uns, bis der Zweck für die Datenverarbeitung 
                      entfällt. Wenn Sie ein berechtigtes Löschersuchen geltend machen oder eine Einwilligung 
                      zur Datenverarbeitung widerrufen, werden Ihre Daten gelöscht.
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-gray-50 dark:bg-surface-dark rounded-lg p-5 md:p-8">
                <h2 className="text-xl md:text-2xl font-bold mb-4 md:mb-6 text-neutral-900 dark:text-neutral-100">
                  4. Datenerfassung auf dieser Website
                </h2>
                
                <div className="space-y-6">
                  <div>
                    <h3 className="text-lg md:text-xl font-semibold mb-2 md:mb-3 text-neutral-900 dark:text-neutral-100">
                      Server-Log-Dateien
                    </h3>
                    <p className="text-neutral-600 dark:text-neutral-400 mb-4">
                      Der Provider der Seiten erhebt und speichert automatisch Informationen in so genannten 
                      Server-Log-Dateien, die Ihr Browser automatisch an uns übermittelt. Dies sind:
                    </p>
                    <ul className="list-disc list-inside mb-4 ml-4 text-neutral-600 dark:text-neutral-400">
                      <li>Browsertyp und Browserversion</li>
                      <li>verwendetes Betriebssystem</li>
                      <li>Referrer URL</li>
                      <li>Hostname des zugreifenden Rechners</li>
                      <li>Uhrzeit der Serveranfrage</li>
                      <li>IP-Adresse</li>
                    </ul>
                    <p className="text-neutral-600 dark:text-neutral-400">
                      Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht vorgenommen. Die 
                      Erfassung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO.
                    </p>
                  </div>

                  <div>
                    <h3 className="text-lg md:text-xl font-semibold mb-2 md:mb-3 text-neutral-900 dark:text-neutral-100">
                      Kontaktformular
                    </h3>
                    <p className="text-neutral-600 dark:text-neutral-400">
                      Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem 
                      Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung 
                      der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben 
                      wir nicht ohne Ihre Einwilligung weiter.
                    </p>
                  </div>

                  <div>
                    <h3 className="text-lg md:text-xl font-semibold mb-2 md:mb-3 text-neutral-900 dark:text-neutral-100">
                      Anfrage per E-Mail oder Telefon
                    </h3>
                    <p className="text-neutral-600 dark:text-neutral-400">
                      Wenn Sie uns per E-Mail oder Telefon kontaktieren, wird Ihre Anfrage inklusive aller 
                      daraus hervorgehenden personenbezogenen Daten (Name, Anfrage) zum Zwecke der Bearbeitung 
                      Ihres Anliegens bei uns gespeichert und verarbeitet.
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-gray-50 dark:bg-surface-dark rounded-lg p-5 md:p-8">
                <h2 className="text-xl md:text-2xl font-bold mb-4 md:mb-6 text-neutral-900 dark:text-neutral-100">
                  5. Ihre Rechte
                </h2>
                <div className="space-y-4">
                  <p className="text-neutral-600 dark:text-neutral-400">
                    Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und Zweck 
                    Ihrer gespeicherten personenbezogenen Daten zu erhalten. Sie haben außerdem ein Recht, die 
                    Berichtigung oder Löschung dieser Daten zu verlangen. Wenn Sie eine Einwilligung zur 
                    Datenverarbeitung erteilt haben, können Sie diese Einwilligung jederzeit für die Zukunft 
                    widerrufen. Außerdem haben Sie das Recht, unter bestimmten Umständen die Einschränkung der 
                    Verarbeitung Ihrer personenbezogenen Daten zu verlangen.
                  </p>
                  <p className="text-neutral-600 dark:text-neutral-400">
                    Des Weiteren steht Ihnen ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu. 
                    Hierzu sowie zu weiteren Fragen zum Thema Datenschutz können Sie sich jederzeit an uns 
                    wenden.
                  </p>
                </div>
              </div>

              <div className="text-center mt-8">
                <p className="text-sm text-neutral-500 dark:text-neutral-400">
                  Stand: Januar 2025
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Datenschutz;